import * as Dialog from '@radix-ui/react-dialog';
import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import { StyledDialogOverlay } from '../Modals';
import type {
  PopupWrapperProps,
  StyledPopupContentProps,
  StyledPopupRootProps,
} from './Popup.types';

export const StyledPopupRoot = styled(Dialog.Root)<StyledPopupRootProps>(() => {
  return {};
}, getAllStyledProps);

export const StyledPopupOverlay = styled(StyledDialogOverlay)(() => {
  return {
    display: 'grid',
    placeItems: 'center',
    overflowY: 'auto',
  };
});

export const StyledPopupContent = styled(Dialog.Content)<StyledPopupContentProps>(
  ({ theme, isFullPage }) => {
    return {
      display: 'flex',
      flexDirection: 'column',
      width: isFullPage ? '100%' : '85%',
      height: isFullPage ? '100%' : 'auto',
      zIndex: theme.zIndex[1050],
      ...(!isFullPage && {
        maxWidth: 600,
        minWidth: 240,
        maxHeight: 1000,
      }),
    };
  },
  getAllStyledProps,
);

export const StyledPopupWrapper = styled('div')<PopupWrapperProps>(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.system.white,
    position: 'relative',
  };
}, getAllStyledProps);
